"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LapPencil_exports = {};
__export(LapPencil_exports, {
  default: () => LapPencil_default
});
module.exports = __toCommonJS(LapPencil_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.3086 3.08203C14.5169 2.8737 14.7708 2.76302 15.0703 2.75C15.3698 2.73698 15.6302 2.82812 15.8516 3.02344L15.9102 3.08203L17.668 4.83984C17.8763 5.04818 17.987 5.30208 18 5.60156C18.013 5.90104 17.9219 6.16146 17.7266 6.38281L17.668 6.42188L7.45312 16.6172L7.41406 16.6367H7.39453L7.35547 16.6562L3.46875 17.7305C3.33854 17.7695 3.22135 17.7435 3.11719 17.6523C3.02604 17.5612 2.98698 17.4505 3 17.3203L3.01953 17.2812L4.05469 13.375L4.07422 13.3164L4.09375 13.2773L4.11328 13.2578L4.13281 13.2383L14.3086 3.08203ZM4.60156 14.2148L3.89844 16.832L6.51562 16.1094L4.60156 14.2148ZM14.9922 6.16797L6.30078 14.8398L7.23828 15.7773L15.9297 7.10547L14.9922 6.16797ZM13.6445 4.82031L4.93359 13.4727L5.77344 14.3125L14.4648 5.64062L13.6445 4.82031ZM15.3633 3.60938C15.2982 3.54427 15.2201 3.51172 15.1289 3.51172C15.0378 3.4987 14.9531 3.51823 14.875 3.57031L14.8359 3.60938L14.1719 4.27344L16.457 6.57812L17.1406 5.89453C17.2057 5.82943 17.2383 5.75781 17.2383 5.67969C17.2513 5.58854 17.2383 5.51042 17.1992 5.44531L17.1797 5.40625L17.1406 5.36719L15.3633 3.60938Z",
      fill: "currentColor"
    }
  )
);
const SvgLapPencil = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LapPencil_default = SvgLapPencil;
